import { APP_CONFIG } from '@/lib/utils';
import MaintenancePage from '@/pages/MaintenancePage';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ALLOWED_PATHS = ['/login']; // optional

const MaintenanceRoute = () => {
  const location = useLocation();

  if (!APP_CONFIG.maintenanceMode) {
    return <Outlet />;
  }

  if (location.pathname === '/maintenance') {
    return <MaintenancePage />;
  }

  if (ALLOWED_PATHS.includes(location.pathname)) {
    return <Outlet />;
  }

  return <Navigate to="/maintenance" replace />;
};

export default MaintenanceRoute;
